import React from 'react';
import MultiEntityContentBars from 'components/Graphs/MultiEntityContentBars';
import ErrorEntityBarChart from 'components/Pages/Reports/ErrorStates/ErrorEntityBarChart.jsx';
import { TileContentContainer, ErrorTitleContainer } from './styled';

const EntityBarChartTile = ({ data }) => {
  /* TODO: implement proper error status checking */
  if (!data.length) {
    return (
      <ErrorTitleContainer>
        <ErrorEntityBarChart />
      </ErrorTitleContainer>
    );
  }
  return (
    <TileContentContainer>
      <MultiEntityContentBars data={data} />
    </TileContentContainer>
  );
};

export default EntityBarChartTile;
